import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-signup',
  standalone: true,
  templateUrl: '../../assets/signup.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSignupIcon {}
